<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      罗湖北站<br>
站点介绍<br>
罗湖北站位于罗湖区清水河五路与清水河一路交叉口，车站主体沿清水河五路南北方向布置，南接黄木岗站，北接布吉站。 罗湖北站以展现现代科技感为出发点，契合整体建筑设计理念，将灯光与造型一体化设计，营造现代简洁的科技氛围。车站为地下三层站，地下一层为综合交通层，地下二层为站厅层，地下三层为站台层，站台形式为侧式站台。车站设置有9个出入口，其中E出入口、J口为预留口，周边为成熟配套生活区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:49	23:47	14号线	4分30秒	6分15秒<br>
沙田	06:07	23:37	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:47	23:47	14号线	5分25秒	6分15秒<br>
沙田	06:07	23:37	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:47	00:47	14号线	5分钟	6分15秒<br>
沙田	06:07	00:37	14号线	5分钟	6分15秒<br><br>

站点出口信息<br><br>
A出口:<br>
清水河一路北侧（东）<br><br>
B出口:<br>
清水河五路东侧（南）、华盛苑<br><br>
C出口:<br>
清水河五路东侧（北）、清水河二路南侧（西）<br><br>
D出口:<br>
清水河五路东侧（北）、环仓路东侧、清水河村<br><br>
F出口:<br>
清水河二路南侧（西）<br><br>
G出口:<br>
清水河五路西侧（北）<br><br>
H出口:<br>
清水河一路北侧（西）、清水河五路西侧（南）、罗湖教科院附属学校<br><br>
公交换乘信息<br><br>
H出入口:<br>
公交站名： 腾邦大厦<br>
M140、M482<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>